const NotificationsBell = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.702 22.6852C18.702 24.2398 17.4092 25.5 15.8144 25.5C14.2196 25.5 12.9268 24.2398 12.9268 22.6852H18.702Z"
      stroke="currentColor"
    />
    <path
      d="M22.8284 22.6852H9.17164C8.33498 22.6852 7.92872 22.0021 8.01026 21.2236C8.02967 21.0383 8.10624 20.8651 8.19919 20.7036L9.46866 18.4976C9.74878 18.0108 9.92325 17.4705 9.98073 16.9119L10.2871 13.9339C10.3143 13.6695 10.353 13.4075 10.4301 13.1531C10.7052 12.2443 11.5981 9.96741 13.8343 9.02724V8.61111C13.8343 7.44518 14.8039 6.5 16 6.5C17.1961 6.5 18.1657 7.44518 18.1657 8.61111V9.02725C20.3271 9.93595 21.2335 12.0933 21.5402 13.0573C21.6411 13.3742 21.685 13.7033 21.7108 14.0349L21.9259 16.8057C21.9746 17.4326 22.1704 18.0391 22.4974 18.5762L23.7817 20.6855C23.8873 20.8589 23.9738 21.0467 23.9923 21.2487C24.0625 22.0167 23.656 22.6852 22.8284 22.6852Z"
      stroke="currentColor"
    />
  </svg>
);

export default NotificationsBell;
